import React, { memo } from 'react';

import { Box } from '@mui/material';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize, LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import { REALTOR_PORTAL_BADGE_TITLE } from '../../RealtorPicker.constants';
import { realtorOptionBadgesStyles, realtorOptionStyles } from '../../RealtorPicker.styles';

const RealtorPickerOption = ({ option, optionText }) => (
  <Box sx={realtorOptionStyles}>
    <Box className="truncate">{optionText}</Box>
    <Box sx={realtorOptionBadgesStyles}>
      <LabelCDS size={LabelSize.S} title={REALTOR_PORTAL_BADGE_TITLE} variant={LabelVariant.BLUE} />
      {option.assignedLoanOfficerLabel && (
        <LabelCDS
          size={LabelSize.S}
          title={option.assignedLoanOfficerLabel}
          variant={LabelVariant.GRAY}
        />
      )}
    </Box>
  </Box>
);

RealtorPickerOption.propTypes = {
  option: PropTypes.shape({
    assignedLoanOfficerLabel: PropTypes.string,
  }).isRequired,
  optionText: PropTypes.string.isRequired,
};

export default memo(RealtorPickerOption);
